import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import HomeButton from './HomeButton'
import AdditionalInfoForm from './AdditionalInfoForm'
import {
  Typography,
  Paper,
  Divider,
  Grid
} from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  container: {
    height: 'auto'
  },
  content: {
    textAlign: 'center',
    padding: '40px 25px 1.5rem 25px'
  },
  divider: {
    marginTop: '1rem',
    marginBottom: '1.5rem'
  },
  pending: {
    marginBottom: '20px'
  }
}))

const AccountAuthorized = ({
    userName,
    handleSubmit,
    handleChange,
    fields,
    handlePhone,
    handleAvatar,
    avatar,
    setIsCropping,
    errors,
    handlePronouns
  }) => {
  const classes = useStyles()

  return(
    <Paper elevation={3} className={classes.container}>
      <div className={classes.content}>
        <Typography variant='h4'>
          Welcome {userName}!
        </Typography>
        <Typography variant='subtitle1'>
          Please fill out the following fields to complete your registration.
        </Typography>
        <Divider className={classes.divider}/>
        <AdditionalInfoForm
          handleChange={handleChange}
          handleSubmit={handleSubmit}
          fields={fields}
          handlePhone={handlePhone}
          handleAvatar={handleAvatar}
          avatar={avatar}
          setIsCropping={setIsCropping}
          errors={errors}
          handlePronouns={handlePronouns}
        />
      </div>
    </Paper>
  )
}

export default AccountAuthorized
